import mod from "-!./school.js?vue&type=script&lang=js&external"; export default mod; export * from "-!./school.js?vue&type=script&lang=js&external"